import React, { useMemo } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Navigate, useSearchParams } from "react-router-dom";
import { legacyTabSlugToPath, PLATFORM_CONSOLE_SECTION_PATH } from "./platformConsoleRoutes";
import { PLATFORM_CONSOLE_GOVERNANCE_SECTION_ORDER, usePlatformConsoleAcl } from "./PlatformConsoleAclContext";
import PlatformConsoleNoAccess from "./PlatformConsoleNoAccess";

/**
 * Rota índice /platform/xprobase: redireciona ?tab= legado ou a primeira seção com view.
 */
const LegacyPlatformRedirect = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const { loading, can } = usePlatformConsoleAcl();

  const to = useMemo(() => {
    if (tab) return legacyTabSlugToPath(tab);
    for (const key of PLATFORM_CONSOLE_GOVERNANCE_SECTION_ORDER) {
      if (can(key, "view")) {
        const path = PLATFORM_CONSOLE_SECTION_PATH[key];
        if (path) return path;
      }
    }
    return null;
  }, [tab, can]);

  if (!tab && loading) {
    return (
      <Box sx={{ py: 6, display: "flex", justifyContent: "center" }} role="status" aria-live="polite">
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (!to) {
    return <PlatformConsoleNoAccess />;
  }

  return <Navigate to={to} replace />;
};

export default LegacyPlatformRedirect;
